import { getABTProvider } from '@/plugins/abt/statsig'

export const MERCHANT_USER_SETTINGS_V2_FLAG =
  'gate_temp_merchant_user_settings_v2'

export const USER_SETTINGS_PATH_V1 = '/profile/index'
export const USER_SETTINGS_PATH_V1_ROOT = '/profile'
export const USER_SETTINGS_PATH_V2 = '/v2/user-settings'

export function isMerchantUserSettingsV2Enabled() {
  return getABTProvider().isFeatureEnabled(MERCHANT_USER_SETTINGS_V2_FLAG)
}

export function getUserSettingsPath() {
  return isMerchantUserSettingsV2Enabled()
    ? USER_SETTINGS_PATH_V2
    : USER_SETTINGS_PATH_V1
}

/** V2 lives outside the hash router — use full-page navigation when the flag is on. */
export function redirectToUserSettingsPath(to = {}) {
  const query = to.query || {}
  const queryString =
    Object.keys(query).length > 0
      ? '?' + new URLSearchParams(query).toString()
      : ''

  window.location.replace(
    window.location.origin + USER_SETTINGS_PATH_V2 + queryString
  )
}

/** V2 lives outside the hash router — use full-page navigation when the flag is on. */
export function navigateToUserSettings(router, { query } = {}) {
  if (isMerchantUserSettingsV2Enabled()) {
    redirectToUserSettingsPath({ query })
    return
  }

  router.push({ path: USER_SETTINGS_PATH_V1, query })
}
